module.exports = __webpack_public_path__ + "static/media/popupQuad.0d46f653.png";